export default {
  actionHere ({ commit, dispatch, state }, formData) {
    // ...
  }
}
